// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ClientEndpointHealthWindow, IClientEndpointHealthWindow } from "./ClientEndpoints.ClientEndpointHealthWindow.gen";
import { ClientEndpointJsonVersion } from "./ClientEndpointJsonVersion.gen";
import { EndpointStatus } from "./Shared.Models.Api.V1.ClientEndpoints.EndpointStatus.gen";
import { ClientEndpointType } from "./Shared.Models.Api.V1.ClientEndpoints.ClientEndpointType.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IFabricClientEndpoint {
	connectionString: string;

	eventHubName: string | undefined;

	jsonVersion: ClientEndpointJsonVersion;

	description: string | undefined;

	status: EndpointStatus;

	lastSuccessUtc: string | undefined;

	lastFailureUtc: string | undefined;

	failingSinceUtc: string | undefined;

	lastFailureMessage: string | undefined;

	consecutiveFailures: number;

	recentSendsConsidered: number;

	recentFailureCount: number;

	recentSlowSendCount: number;

	recentMaxMs: number | undefined;

	health: IClientEndpointHealthWindow | undefined;

	inUse: boolean;

	reportsDeliveryHistory: boolean;

	facilityName: string | undefined;

	deliversFromDevice: boolean;

	minimumFirmwareVersion: string | undefined;

	id: string | undefined;

	facilityId: string | undefined;

	organizationId: string | undefined;

	endpointName: string;

	enableHeartbeat: boolean;

	secondsBetweenHearbeat: number;

	includeTargetHistory: boolean;

	endpointType: ClientEndpointType;

	lastModifiedBy: string | undefined;

	lastModified: string | undefined;

	$type?: string | undefined;
}
export class FabricClientEndpoint {
	constructor(data?: IFabricClientEndpoint) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.lastSuccessUtc) { this.lastSuccessUtc = new Date(data.lastSuccessUtc); }
		if (data.lastFailureUtc) { this.lastFailureUtc = new Date(data.lastFailureUtc); }
		if (data.failingSinceUtc) { this.failingSinceUtc = new Date(data.failingSinceUtc); }
		if (data.health) { this.health = new ClientEndpointHealthWindow(data.health); }
		if (data.lastModified) { this.lastModified = new Date(data.lastModified); }
	}

	@IsNotEmpty()
	connectionString: string = "";

	eventHubName: string | undefined;

	jsonVersion: ClientEndpointJsonVersion = 1;

	description: string | undefined;

	status: EndpointStatus = 0;

	lastSuccessUtc: Date | undefined;

	lastFailureUtc: Date | undefined;

	failingSinceUtc: Date | undefined;

	lastFailureMessage: string | undefined;

	consecutiveFailures: number = 0;

	recentSendsConsidered: number = 0;

	recentFailureCount: number = 0;

	recentSlowSendCount: number = 0;

	recentMaxMs: number | undefined;

	health: ClientEndpointHealthWindow | undefined;

	inUse: boolean = false;

	reportsDeliveryHistory: boolean = false;

	facilityName: string | undefined;

	deliversFromDevice: boolean = false;

	minimumFirmwareVersion: string | undefined;

	id: string | undefined;

	facilityId: string | undefined;

	organizationId: string | undefined;

	@IsNotEmpty()
	endpointName: string = "";

	enableHeartbeat: boolean = false;

	secondsBetweenHearbeat: number = 0;

	includeTargetHistory: boolean = false;

	@IsNotEmpty()
	endpointType: ClientEndpointType = 1;

	lastModifiedBy: string | undefined;

	lastModified: Date | undefined;

	static $type: string = "CoreApi.Models.ClientEndpoints.FabricClientEndpoint, ";
	$type?: string | undefined = FabricClientEndpoint.$type;
}

